import type {
	SettingsFlow,
	UpdateSettingsFlowBody,
	UpdateSettingsFlowWithTotpMethod,
} from "@ory/kratos-client";
import type React from "react";
import { Flow } from "~/components/KratosFlow";
import { validateTotpCode } from "~/validator";

interface Props {
	flow: SettingsFlow;
	onSubmit: (values: UpdateSettingsFlowBody) => Promise<void>;
}

export const TotpSettings: React.FC<Props> = ({ flow, onSubmit }) => {
	return (
		<Flow<UpdateSettingsFlowWithTotpMethod & { method: "totp" }>
			onSubmit={onSubmit}
			flow={flow}
			only="totp"
			setLabelTexts={[
				{
					query: { name: "totp_unlink", type: "submit" },
					value: "Reset Authenticator",
				},
				{
					query: { name: "totp_code" },
					value: "verification code",
				},
				{
					query: { name: "method", type: "submit", value: "totp" },
					value: "Configure Authenticator App",
				},
			]}
			setLabelTypes={[
				{
					query: { name: "totp_unlink", type: "submit" },
					value: "error",
				},
			]}
			beforeComponents={[
				{
					query: { id: "totp_qr", node_type: "img" },
					component: () => (
						<p className="mt-6">
							Scan the image below with the two-factor authentication app (for
							example,{" "}
							<a
								href="https://authy.com/"
								target="_blank"
								rel="noopener noreferrer"
							>
								Authy
							</a>{" "}
							or{" "}
							<a
								href="https://support.1password.com/one-time-passwords/"
								target="_blank"
								rel="noopener noreferrer"
							>
								1Password
							</a>
							) on your phone.
						</p>
					),
				},
			]}
			nodeDisablers={[
				{
					target: { name: "method", value: "totp" },
					keys: ["totp_code"],
					allowEmpty: false,
					allowNotChanged: false,
					validators: [
						{
							key: "totp_code",
							validate: (value): boolean => {
								if (typeof value !== "string") return false;
								return validateTotpCode(value);
							},
						},
					],
				},
			]}
		/>
	);
};
